import { render } from "./QuestionnaireNewPassword.vue?vue&type=template&id=2cc7884a&scoped=true&ts=true"
import script from "./QuestionnaireNewPassword.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireNewPassword.vue?vue&type=script&lang=ts"

import "./QuestionnaireNewPassword.vue?vue&type=style&index=0&id=2cc7884a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1028913207/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc7884a"]])

export default __exports__